// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RowSection .RowSection__title {\n  font-size: 16px;\n  font-weight: bold;\n  padding: 8px;\n  border-bottom: 2px solid lightgray;\n  border-top: 2px solid lightgray;\n  background: #f0f0ff; }\n\n.RowSection .RowSection__amount {\n  font-size: 16px;\n  font-weight: bold;\n  padding: 8px;\n  text-align: right;\n  font-family: monospace;\n  border-bottom: 2px solid lightgray;\n  border-top: 2px solid lightgray;\n  background: #f0f0ff; }\n", ""]);
// Exports
module.exports = exports;
